var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 3.49992H3.50016C2.85583 3.49992 2.3335 4.02225 2.3335 4.66659V10.4999C2.3335 11.1443 2.85583 11.6666 3.50016 11.6666H9.3335C9.97783 11.6666 10.5002 11.1443 10.5002 10.4999V8.16659M11.6668 5.83325V2.33325H8.16683M11.6668 2.33325L5.8335 8.16659",
    stroke: "#808089",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDetails);
export default __webpack_public_path__ + "static/media/ViewDetails.a05598631c51a45e1d5cbf09ca803729.svg";
export { ForwardRef as ReactComponent };